<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="isMobile()"
    max-width="700"
    scrollable
  >
    <v-card>
      <toolbar-card-visita
        :opcao_checklist="
          configuracoes.dados.opcoes_checklist.find((oc) => oc.rota == '/observacoes-gerais')
        "
      />
      <v-card-text>
        <v-row
          :dense="isMobile()"
          :class="{ 'mt-6': !isMobile(), 'mt-8': isMobile() }"
        >
          <v-col cols="12">
            <v-textarea
              label="Observações Gerais"
              outlined
              rows="12"
              auto-grow
              persistent-placeholder
              placeholder="Descreva informações importantes ou detalhes adicionais observados durante a visita. Ex.: condições do ambiente, comportamento dos animais, orientações dadas ou outros detalhes essenciais."
              v-model="visita.obs_gerais"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <btn-salvar-dados-visita />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import BtnSalvarDadosVisita from "./BtnSalvarDadosVisita.vue";
import ToolbarCardVisita from "./ToolbarCardVisita.vue";
export default {
  components: { ToolbarCardVisita, BtnSalvarDadosVisita },
  computed: mapState("visitaTecnica", ["configuracoes","visita"]),
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      }
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
  mounted() {
    this.dialog = true;
  },
};
</script>

<style>
</style>